import _ from "lodash";
import React from "react";
import CSSModules from "lib/utils/css-modules";
import "./form.css";
import {
  Form,
  FormMessage,
  Grid,
  Button,
  Menu,
  OrderFullDecorator,
  OrderInstallmentDecorator,
  OrderTransferDecorator,
  OrderItemDecorator,
  st,
  FormControl,
  FormSection,
  UsersRepository,
} from "lib/index";
import { calculatePricing, stateSelector } from "./../index";
import styles from "./NewOrderPaymentsForm.less";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import "./test.css";
import OrderStatusLabel from "lib/components/OrderStatusLabel";

const MODE_PAY_NOW = "MODE_PAY_NOW";
const MODE_PLAN_PAYMENTS = "MODE_PLAN_PAYMENTS";
const MODE_NO_PAYMENTS = "MODE_NO_PAYMENTS";

const getReceiver = () => (st.authorize.company.agent || st.authorize.company.reseller ? "agent" : "supplier");

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    opened: stateSelector(state).opened,
    step: stateSelector(state).step,
    stepLoading: stateSelector(state).stepLoading,
    order: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
    slots: stateSelector(state).slotsData.model,
    calculateLoading: stateSelector(state).calculate.fetchLoading,
    calculateFailed: stateSelector(state).calculate.fetchFailed,
    submitLoading: stateSelector(state).form.submitLoading,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        calculatePricing,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class NewOrderPaymentsForm extends React.PureComponent {
  state = {
    orderStatus: null,
    mode: MODE_PLAN_PAYMENTS,
    hasPartDeposit: null,
    depositTransferType: null,
    partDepositAmount: null,
    remainingInstallmentTransferType: null,
    remainingInstallmentPaidByAt: null,
    notify_customer: "true",
  };

  constructor(props) {
    super(props);
    this.tileClicked.bind(this);
  }

  componentDidMount() {
    const { order, onOrderUpdate, currentCompany } = this.props;

    let mode = null;
    if ((currentCompany.reseller || st.authorize.company.agent) && currentCompany.payment_terminal) {
      mode = MODE_PAY_NOW;
    } else if ((currentCompany.reseller || st.authorize.company.agent) && !currentCompany.payment_terminal) {
      mode = MODE_PLAN_PAYMENTS;
    } else {
      if (order.payment_profile_id || (order.installments.length && !order.order_transfers.length)) {
        mode = MODE_PLAN_PAYMENTS;
      } else if (order.installments.length && order.order_transfers.length) {
        mode = MODE_PAY_NOW;
      } else if (order.total_amount_sum.filter((amount) => amount.value !== 0).length === 0) {
        mode = MODE_NO_PAYMENTS;
      }
    }
    this.getUsers();
    this.handleChangeMode(mode);
    const notify_customer = "true";

    let nextOrder = new OrderFullDecorator({
      ...order,
      notify_customer: notify_customer,
      notify_supplier: true,
      assigned_creator_id: null,
      isReseller: currentCompany.reseller || st.authorize.company.agent,
      affiliate_id: st.authorize.company.reseller ? "" + currentCompany.id : undefined,
    });
    if (order.installments.length > 0 || order.order_transfers.length > 0) {
      nextOrder = new OrderFullDecorator({
        ...nextOrder,
        order_transfers:
          order.order_transfers &&
          order.order_transfers.map((data) => ({
            ...data,
            id: undefined,
          })),
        installments:
          order.installments &&
          order.installments.map((data) => ({
            ...data,
            id: undefined,
          })),
      });
    }

    // select first tile by default
    this.handleOrderPropChange("notify_customer", true);
    if (order && order.possible_payment_profiles && order.possible_payment_profiles.length) {
      this.tileClicked(order.possible_payment_profiles[0]);
    }

    onOrderUpdate(nextOrder);
  }

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }

  subscriptions = [];
  getUsers() {
    //get users
    const sub = UsersRepository.getAll().subscribe((users) => {
      let isCurrentUserPresent = false;
      let filteredUsers = [];
      window.users = users;
      users.map((u) => {
        filteredUsers.push([u.id, u.admin_user.full_name]);

        // check if currently logged in user in present on the list
        if (u.id === st.authorize.member.id) {
          isCurrentUserPresent = true;
        }
      });

      // if its not present - add it.
      if (!isCurrentUserPresent) {
        filteredUsers.push([st.authorize.member.id, st.authorize.user.full_name]);
      }
      this.setState({ users: filteredUsers });

      // default value to the logged in user
      this.handleStatePropChange("assigned_creator_id", st.authorize.member.id);
    });
    this.subscriptions.push(sub);
  }
  handleSubmit(event) {
    event.preventDefault();

    this.props.onSave();
  }

  handleChangeMode(mode) {
    const { order, currentCompany } = this.props;

    if (mode === MODE_PAY_NOW) {
      if (currentCompany.reseller || st.authorize.company.agent) {
        this.setState((prevState) => ({
          ...prevState,
          orderStatus: "approved",
        }));
      }
      this.updateState({
        mode,
        hasPartDeposit: false,
        depositTransferType: "cash",
        partDepositAmount: order.total_base_amount,
        remainingInstallmentTransferType: "cash",
        remainingInstallmentPaidByAt: order.stock_starts_at || moment(),
      });
    } else if (mode === MODE_PLAN_PAYMENTS) {
      if (currentCompany.reseller || st.authorize.company.agent) {
        this.setState((prevState) => ({
          ...prevState,
          orderStatus: "waiting_for_customer_approval",
        }));
        if (order.possible_payment_profiles && order.possible_payment_profiles.length) {
          this.updateState({
            mode,
            paymentProfileId: order.possible_payment_profiles[0].id,
          });
        }
        return;
      }
      this.updateState({
        mode,
        paymentProfileId: order.possible_payment_profiles.length === 1 ? order.possible_payment_profiles[0].id : null,
      });
    } else {
      this.updateState({
        mode,
        paymentProfileId: order.possible_payment_profiles.length === 1 ? order.possible_payment_profiles[0].id : null,
      });
    }
  }

  handleStatePropChange(prop, value) {
    this.updateState({
      [prop]: value,
    });
    if (prop === "paymentProfileId") {
      //this.props.calculatePricing();
      // this.props.order.recalculate();
    }
  }

  updateState(nextState) {
    this.setState(nextState, () => {
      this.updateOrderWithState();
    });
  }

  updateOrderWithState() {
    const { currentCompany, order, onOrderUpdate } = this.props;
    const isAgent = order.agent && order.agent.id === currentCompany.id;
    const {
      mode,
      hasPartDeposit,
      depositTransferType,
      partDepositAmount,
      remainingInstallmentTransferType,
      remainingInstallmentPaidByAt,
      paymentProfileId,
      assigned_creator_id,
    } = this.state;
    let payment_profile_id = paymentProfileId || null;
    let payment_profile_name = this.state.payment_profile_name || null;
    let cancellation_policy = null;
    let order_transfers = [];
    let installments = order.installments || [];
    let order_items = order.order_items.filter((item) => item.item_type !== "payment_profile_service_fee");
    if (mode === MODE_PAY_NOW) {
      if (currentCompany.reseller || st.authorize.company.agent) {
        this.setState((prevState) => ({
          ...prevState,
          orderStatus: "approved",
        }));
      }

      if (hasPartDeposit) {
        const partDepositTransfer = new OrderTransferDecorator({
          uuid: st.generateUuid(),
          sender: "customer",
          receiver: getReceiver(),
          transfer_type: depositTransferType,
          amount: partDepositAmount,
          transferred_at: moment().format(moment.RUBY_DATETIME_FORMAT),
        });

        const partDepositInstallment = new OrderInstallmentDecorator({
          uuid: st.generateUuid(),
          receiver: getReceiver(),
          transfer_type: partDepositTransfer.transfer_type, // for resellers -> receiver must be "agent" (socialtravel),
          amount_type: "exact_amount",
          amount: partDepositTransfer.amount,
          account_description:
            partDepositTransfer.transfer_type == "bank_wire"
              ? isAgent
                ? order.agent.bank_wire_account_description
                : order.company.bank_wire_account_description
              : null,
          paid_by_type: "exact_date",
          paid_by_at: partDepositTransfer.transferred_at,
          confirmation_installment: false,
          paid_after_company_approval: true,
          position: 1,
        });
        const remainingInstallment = new OrderInstallmentDecorator({
          uuid: st.generateUuid(),
          receiver: "supplier",
          transfer_type: remainingInstallmentTransferType,
          amount_type: "remaining_amount",
          account_description:
            remainingInstallmentTransferType == "bank_wire" ? order.company.bank_wire_account_description : null,
          paid_by_type: "exact_date",
          paid_by_at: remainingInstallmentPaidByAt,
          confirmation_installment: false,
          paid_after_company_approval: true,
          position: 2,
        });
        order_transfers = [partDepositTransfer];
        installments = [partDepositInstallment, remainingInstallment];
      } else {
        const depositTransferredAt = moment().format(moment.RUBY_DATETIME_FORMAT);
        const depositTransfers = order.total_amount_sum.map(
          (amount) =>
            new OrderTransferDecorator({
              uuid: st.generateUuid(),
              sender: "customer",
              receiver: getReceiver(),
              transfer_type: depositTransferType,
              amount,
              transferred_at: depositTransferredAt,
            })
        );
        const depositInstallment = new OrderInstallmentDecorator({
          uuid: st.generateUuid(),
          receiver: getReceiver(),
          transfer_type: depositTransferType,
          amount_type: "remaining_amount",
          account_description: isAgent
            ? order.agent.bank_wire_account_description
            : order.company.bank_wire_account_description,
          paid_by_type: "exact_date",
          paid_by_at: depositTransferredAt,
          confirmation_installment: false,
          paid_after_company_approval: true,
          position: 1,
        });
        order_transfers = depositTransfers;
        installments = [depositInstallment];
      }
    } else if (mode === MODE_PLAN_PAYMENTS) {
      if (this.props.currentCompany.reseller || st.authorize.company.agent) {
        this.setState((prevState) => ({
          ...prevState,
          orderStatus: "waiting_for_customer_approval",
        }));
      }

      const paymentProfile = order.possible_payment_profiles.find((pp) => pp.id === paymentProfileId);
      if (paymentProfile) {
        payment_profile_name = paymentProfile.name;
        cancellation_policy = paymentProfile.cancellation_policy;

        let installmentPosition = 1;
        installments = _.compact(
          paymentProfile.installments.map((ppInstallment) => {
            let amount, amount_type;
            if (ppInstallment.amount_type === "remaining_amount") {
              amount = null;
              amount_type = "remaining_amount";
            } else if (ppInstallment.amount_type === "percentage_amount") {
              amount = {
                value: (ppInstallment.amount_percentage / 100) * order.total_base_amount.value,
                currency: order.total_base_amount.currency,
              };
              amount_type = "exact_amount";
            } else if (ppInstallment.amount_type === "exact_amount_per_order") {
              amount_type = "exact_amount";
              amount = {
                value: ppInstallment.amount.value,
                currency: ppInstallment.amount.currency,
              };
            } else if (ppInstallment.amount_type === "exact_amount_per_item") {
              amount_type = "exact_amount";
              amount = {
                value: ppInstallment.amount.value * order.product_quantity,
                currency: ppInstallment.amount.currency,
              };
            } else if (ppInstallment.amount_type === "exact_amount_per_person") {
              amount_type = "exact_amount";
              amount = {
                value: ppInstallment.amount.value * order.persons_count,
                currency: ppInstallment.amount.currency,
              };
            }

            if (
              ppInstallment.increase_amount_by_marketplace_service_fee &&
              order.marketplace_service_fee_amount &&
              amount_type !== "remaining_amount"
            ) {
              if (amount.value > 0 && amount.currency !== order.marketplace_service_fee_amount.currency) {
                throw `In order #${order.id} installment's amount has different currency (${amount.currency}) than marketplace_service_fee (${order.marketplace_service_fee_amount.currency})`;
              }
              amount.value =
                amount.value > 0
                  ? amount.value + order.marketplace_service_fee_amount.value
                  : order.marketplace_service_fee_amount.value;
            }

            if (
              ppInstallment.increase_amount_by_marketplace_commision &&
              order.marketplace_commision_amount &&
              amount_type !== "remaining_amount"
            ) {
              if (amount.value > 0 && amount.currency !== order.marketplace_commision_amount.currency) {
                throw `In order #${order.id} installment's amount has different currency (${amount.currency}) than marketplace_commision (${order.marketplace_commision_amount.currency})`;
              }
              amount.value =
                amount.value > 0
                  ? amount.value + order.marketplace_commision_amount.value
                  : order.marketplace_commision_amount.value;
            }

            if (amount_type === "exact_amount" && !amount.value) {
              return;
            }
            let receiver = null;
            if (ppInstallment.receiver == "company") {
              receiver = ppInstallment.receiver;
            } else {
              receiver = ppInstallment.receiver == "agent" && order.agent ? "agent" : "supplier";
            }

            const account_description =
              ppInstallment.transfer_type == "bank_wire"
                ? receiver === "agent"
                  ? order.agent.bank_wire_account_description
                  : order.company.bank_wire_account_description
                : null;
            return new OrderInstallmentDecorator({
              uuid: st.generateUuid(),
              receiver,
              transfer_type: ppInstallment.transfer_type,
              amount_type,
              amount,
              assigned_creator_id,
              account_description,
              confirmation_installment: ppInstallment.confirmation_installment,
              paid_after_company_approval: ppInstallment.paid_after_company_approval,
              paid_by_type: ppInstallment.paid_by_type,
              paid_by_time_duration: ppInstallment.paid_by_time_duration,
              paid_by_at: ppInstallment.paid_by_at,
              position: installmentPosition++,
            });
          })
        );

        if (paymentProfile && paymentProfile.has_additional_fee) {
          const ppServiceFee = new OrderItemDecorator({
            uuid: "ppServiceFee",
            item_type:
              paymentProfile.additional_fee_as_agent_fee && order.agent
                ? "agent_service_fee"
                : "payment_profile_service_fee",
            base_item: false,
            name: paymentProfile.additional_fee_name,
            quantity: 1,
            unit_price: paymentProfile.additional_fee_percentage
              ? {
                  value: (paymentProfile.additional_fee_percentage / 100) * order.total_base_amount.value,
                  currency: order.total_base_amount.currency,
                }
              : paymentProfile.additional_fee,
          });
          order_items = [...order_items.filter((item) => item.uuid !== "ppServiceFee"), ppServiceFee];
        }
      }
    } else if (mode === MODE_NO_PAYMENTS || mode === null) {
      // do nothing
    } else {
      throw new Error(`Unknown this.state.mode ${mode}`);
    }

    const nextOrder = new OrderFullDecorator({
      ...order,
      _NewOrderPaymentsMode: mode,
      status: this.state.orderStatus,
      payment_profile_id,
      payment_profile_name,
      cancellation_policy,
      order_transfers,
      installments,
      order_items,
      assigned_creator_id,
    });

    nextOrder.recalculate();
    onOrderUpdate(nextOrder);
  }

  handleOrderPropChange(prop, value) {
    const { order, onOrderUpdate } = this.props;

    onOrderUpdate(
      new OrderFullDecorator({
        ...order,
        [prop]: value,
      })
    );
  }

  tileClicked(pp) {
    this.handleChangeMode(MODE_PLAN_PAYMENTS);

    this.setState({ activePPid: pp.id, showSecondayTiles: pp.payment_type !== "offline" });

    this.handleStatePropChange("paymentProfileId", pp.id);

    const isAgentOrReseller = st.authorize.company.agent || st.authorize.company.reseller;
    const isInstant = !this.props.order.requires_company_approval;

    const isOnlinePayment = pp.payment_type !== "offline";
    const order = this.props.order;
    const company = st.authorize.company;

    const isSupplier = order.supplier_id === company.id;

    if (isSupplier) {
      if (!isOnlinePayment) {
        this.handleStatePropChange("orderStatus", "approved");
      } else {
        this.handleStatePropChange("orderStatus", "waiting_for_customer_approval");
      }
      this.handleOrderPropChange("notify_customer", "true");
    } else if (isAgentOrReseller) {
      if (isOnlinePayment) {
        this.handleStatePropChange("orderStatus", "waiting_for_customer_approval");
        // send email
        this.handleOrderPropChange("notify_customer", "true");
      } else {
        if (isInstant) {
          this.handleStatePropChange("orderStatus", "approved");
          // send email
          this.handleOrderPropChange("notify_customer", "true");
        } else {
          this.handleStatePropChange("orderStatus", "waiting_for_company_approval");
        }
      }
    }
    // always notify customer
    this.handleOrderPropChange("notify_customer", "true");
  }

  getTileClassName(icon) {
    if (icon === "cc-stripe") {
      return "fab fa-cc-stripe fa-5x";
    }
    if (icon === "credit-card") {
      return "far fa-credit-card fa-5x";
    }
    if (icon === "hand-holding-usd") {
      return "fas fa-hand-holding-usd fa-5x";
    }
    if (icon === "dollar-sign") {
      return "fas fa-dollar-sign fa-5x";
    }
    if (icon === "creative-commons-nc") {
      return "fab fa-creative-commons-nc fa-5x";
    }
    if (icon === "terminal") {
      return "terminal-icon";
    }

    return icon;
  }

  render() {
    const { order, currentCompany, valid, loading, errors, onValidate } = this.props;
    const {
      mode,
      hasPartDeposit,
      depositTransferType,
      partDepositAmount,
      remainingInstallmentTransferType,
      remainingInstallmentPaidByAt,
      paymentProfileId,
      assigned_creator_id,
      users,
    } = this.state;
    const ppServiceFee = order.order_items.find((item) => item.item_type === "payment_profile_service_fee");
    const isAgent = order.agent && order.agent.id === currentCompany.id;
    const statusOptions = [
      "building",
      "waiting_for_company_approval",
      "waiting_for_customer_approval",
      ...(st.authorize("set_any_status", order) || !order.requires_company_approval ? ["approved"] : []),
      ...(st.authorize("set_any_status", order) ? ["finished"] : []),
    ].map((status) => [status, I18n.humanAttributeName("order", status)]);

    const isReseller = currentCompany.reseller || st.authorize.company.agent;
    const hasTerminal = currentCompany.payment_terminal;

    const notify_options = [
      [
        "false",
        I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_reseller"),
        [
          I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_reseller_hint1"),
          <br key={Math.random()} />,
          <br key={Math.random()} />,
          I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_reseller_hint2"),
        ],
      ],
      [
        "true",
        I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_customer"),
        [
          I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_customer_hint1"),
          <br key={Math.random()} />,
          <br key={Math.random()} />,
          I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments_customer_hint2"),
        ],
      ],
    ];

    return (
      <div>
        {!!errors.base && <FormMessage error={errors.base} />}

        <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} styleName="container">
          <h3>{I18n.t("papp.orders.NewOrderModal.payments_step_profiles_instruction")}</h3>
          <div styleName="pp-tiles-container">
            {order.possible_payment_profiles.map((pp) => (
              <div
                key={pp.id}
                styleName={"pp-tile"}
                className={this.state.activePPid === pp.id ? "active-pp" : ""}
                onClick={() => this.tileClicked(pp)}
              >
                <p>
                  <em className={this.getTileClassName(pp.icon)}></em>
                </p>
                <p>{pp.name}</p>
              </div>
            ))}
          </div>
          {this.state.showSecondayTiles && (
            <div className="reseller-form-payment">
              <FormControl.MultipleRadioFormGroup
                {...FormControl.addProps(`order.notify_customer`, {
                  errors,
                })}
                inlineLabel
                withDescription
                inline
                label={I18n.t("papp.orders.NewOrderModal.payments_step_choose_payments")}
                value={order.notify_customer}
                onChange={this.handleOrderPropChange.bind(this, "notify_customer")}
                options={notify_options}
              />
            </div>
          )}

          <Grid columns={1}>
            <Grid.Column>
              <p>
                <strong>
                  {I18n.t("papp.orders.NewOrderPaymentsForm.order_status_message")}
                  <OrderStatusLabel shortLabel status={order.status} />
                </strong>
              </p>
              <p>
                <br />
              </p>
            </Grid.Column>
          </Grid>

          <div styleName="others-container">
            <Grid columns={2}>
              <Grid.Column>
                <FormControl.TextAreaFormGroup
                  value={order.internal_note}
                  onChange={this.handleOrderPropChange.bind(this, "internal_note")}
                  onBlur={onValidate}
                  label={I18n.humanAttributeName("order", "internal_note")}
                  placeholder={I18n.t("papp.orders.NewOrderPaymentsForm.note_placeholder")}
                  autoHeight
                />

                {order.supplier_id === st.authorize.company.id && (
                  <FormControl.TextAreaFormGroup
                    value={order.supplier_note}
                    onChange={this.handleOrderPropChange.bind(this, "supplier_note")}
                    onBlur={onValidate}
                    label={I18n.humanAttributeName("order", "supplier_note")}
                    placeholder={I18n.t("papp.orders.NewOrderPaymentsForm.note_placeholder")}
                    autoHeight
                  />
                )}

                {(st.authorize.company.agent || st.authorize.company.reseller) && (
                  <FormControl.TextAreaFormGroup
                    value={order.agent_note}
                    onChange={this.handleOrderPropChange.bind(this, "agent_note")}
                    onBlur={onValidate}
                    label={I18n.humanAttributeName("order", "agent_note")}
                    placeholder={I18n.t("papp.orders.NewOrderPaymentsForm.note_placeholder")}
                    autoHeight
                  />
                )}

                {st.authorize("update_st_note", order) && (
                  <FormControl.TextAreaFormGroup
                    value={order.st_note}
                    onChange={this.handleOrderPropChange.bind(this, "st_note")}
                    onBlur={onValidate}
                    label={I18n.humanAttributeName("order", "st_note")}
                    placeholder={I18n.t("papp.orders.NewOrderPaymentsForm.note_placeholder")}
                    autoHeight
                  />
                )}
              </Grid.Column>
              <Grid.Column>
                {!!order.customer_email && (
                  <FormControl.TextAreaFormGroup
                    value={order.additional_information}
                    onChange={this.handleOrderPropChange.bind(this, "additional_information")}
                    onBlur={onValidate}
                    label={I18n.humanAttributeName("order", "additional_information")}
                    placeholder={I18n.t("papp.orders.NewOrderPaymentsForm.note_placeholder")}
                    autoHeight
                  />
                )}
              </Grid.Column>
            </Grid>
          </div>

          <button type="submit" disabled={loading} hidden />
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/NewOrderModal/NewOrderPaymentsForm/NewOrderPaymentsForm.jsx